import { useClaimStore } from "@/store";

import ClaimsLegalSteps from "@upclaim/prisma/seeds/claims_legal_steps.json";
import { ClaimLegalStep } from "@/interfaces/data-contracts";

export type ClaimLegalStepName = ClaimLegalStep['name'];

const LegalStepsByName = new Map(ClaimsLegalSteps.map(cs => [cs.name as ClaimLegalStepName, cs]));

function claimLegalStepByName(name: ClaimLegalStepName) {
  const legalStep = LegalStepsByName.get(name);
  if (!legalStep) throw `Type error: No legal step named "${name}"`
  return legalStep;
}

function claimLegalStepById(id: number) : ClaimLegalStepName {
  const claimStep = ClaimsLegalSteps.find(cls => cls.id === id);
  if (!claimStep) throw `No claim step found with id ${id}`;
  return claimStep.name as ClaimLegalStepName;
}

function isCurrentStepAfter(name: ClaimLegalStepName) {
  const { claim } = useClaimStore();
  const claimLegalStep = claimLegalStepByName(name);

  return claim.claimLegalStep.id > claimLegalStep.id
}

/** @see safelisted colors in tailwind.config */
type safeListedTailwindColors = "teal" | "red" | "amber" | "indigo" | "blue" | "green" | "lime" | "gray" | "black" | "violet" | "yellow" | "zinc";

type LegalSteps = {
  [key in ClaimLegalStepName]: {
    color: safeListedTailwindColors;
    displayText: string;
  }
}

const legalSteps: LegalSteps = {
  CLAIM_VALIDATION: {
    color: "teal",
    displayText: "Validation"
  },
  UPCLAIM: {
    color: "blue",
    displayText: "Amiable",
  },
  CONCILIATION: {
    color: "amber",
    displayText: "Précontentieux",
  },
  COURT: {
    color: "red",
    displayText: "Contentieux",
  },
  BAILIFF: {
    color: "indigo",
    displayText: "Huissier",
  },
  CANCELLED: {
    color: "gray",
    displayText: "Abandon",
  },
  LOST: {
    color: "gray",
    displayText: "Perdu",
  },
  WAITING_FOR_MONEY: {
    color: "violet",
    displayText: "Attente de paiement",
  },
  MONEY_RECEIVED: {
    color: "green",
    displayText: "Paiement reçu",
  },
  PAYMENT_SENT: {
    color: "lime",
    displayText: "Paiement envoyé",
  },
}

function getColor(name: ClaimLegalStepName) : safeListedTailwindColors {
  return legalSteps[name].color
}

function getColorById(id: number) : safeListedTailwindColors {
 return getColor(claimLegalStepById(id));
}

export {
  claimLegalStepByName,
  claimLegalStepById,
  isCurrentStepAfter,
  ClaimsLegalSteps,
  legalSteps,
  getColor,
  getColorById
}
